import { render } from "./channel.vue?vue&type=template&id=e48c7cde&scoped=true"
import script from "./channel.vue?vue&type=script&lang=js"
export * from "./channel.vue?vue&type=script&lang=js"

import "./channel.vue?vue&type=style&index=0&id=e48c7cde&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-case/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48c7cde"]])

export default __exports__